export default __webpack_public_path__ + "static/media/IMG_1375.104ae745.jpg";